import { call, put, takeEvery, select } from "redux-saga/effects";
import {
  getOnboardingSeedData,
  getOnboardingData,
  saveOnboardingData,
  inviteUsers,
  getPeers,
  getFirstOnboardingSteps,
  saveFirstOnboardingSteps,
} from "src/web-services";
import { OnboardingCreators, OnboardingTypes } from "../actions";

const authTokenSelector = state => state.user.authToken;

export function* requestGetOnboardingSeedData(action) {
  try {
    const { userId } = action;
    const authToken = yield select(authTokenSelector);
    const response = yield call(
      getOnboardingSeedData,
      authToken,
      userId,
    );
    yield put(
      OnboardingCreators.getOnboardingSeedDataSuccess(response.data),
    );
  } catch (error) {
    yield put(OnboardingCreators.getOnboardingSeedDataFailure());
  }
}

export function* requestGetOnboardingData(action) {
  try {
    const { userId } = action;
    const authToken = yield select(authTokenSelector);
    const response = yield call(getOnboardingData, authToken, userId);
    yield put(
      OnboardingCreators.getOnboardingDataSuccess(response.data),
    );
  } catch (error) {
    yield put(OnboardingCreators.getOnboardingDataFailure());
  }
}

export function* requestGetPeers(action) {
  try {
    const { userId } = action;
    const authToken = yield select(authTokenSelector);
    const response = yield call(getPeers, authToken, userId);
    yield put(OnboardingCreators.getPeersSuccess(response.data));
  } catch (error) {
    yield put(OnboardingCreators.getPeersFailure());
  }
}

export function* requestSaveOnboardingData(action) {
  try {
    const { userId, data } = action;
    const authToken = yield select(authTokenSelector);
    const response = yield call(
      saveOnboardingData,
      authToken,
      userId,
      data,
    );
    yield put(
      OnboardingCreators.getOnboardingDataSuccess(response.data),
    );
  } catch (error) {
    yield put(OnboardingCreators.getOnboardingDataFailure());
  }
}

export function* requestInviteUsers(action) {
  try {
    const { data } = action;
    const authToken = yield select(authTokenSelector);
    const response = yield call(inviteUsers, authToken, data);
    yield put(OnboardingCreators.inviteUsersSuccess(response.data));
  } catch (error) {
    yield put(OnboardingCreators.inviteUsersFailure());
  }
}

export function* requestGetFirstOnboardingSteps(action) {
  try {
    const { userId } = action;
    const authToken = yield select(authTokenSelector);
    const response = yield call(
      getFirstOnboardingSteps,
      authToken,
      userId,
    );
    yield put(
      OnboardingCreators.getFirstOnboardingStepsSuccess(
        response.data,
      ),
    );
  } catch (error) {
    yield put(OnboardingCreators.getFirstOnboardingStepsFailure());
  }
}

export function* requestSaveFirstOnboardingSteps(action) {
  try {
    const { userId, data } = action;
    const authToken = yield select(authTokenSelector);
    const response = yield call(
      saveFirstOnboardingSteps,
      authToken,
      userId,
      data,
    );
    yield put(
      OnboardingCreators.saveFirstOnboardingStepsSuccess(
        response.data,
      ),
    );
  } catch (error) {
    yield put(OnboardingCreators.saveFirstOnboardingStepsFailure());
  }
}

export function* watchOnboardingRequests() {
  yield takeEvery(
    OnboardingTypes.GET_ONBOARDING_SEED_DATA_REQUEST,
    requestGetOnboardingSeedData,
  );
  yield takeEvery(
    OnboardingTypes.GET_ONBOARDING_DATA_REQUEST,
    requestGetOnboardingData,
  );
  yield takeEvery(OnboardingTypes.GET_PEERS_REQUEST, requestGetPeers);
  yield takeEvery(
    OnboardingTypes.SAVE_ONBOARDING_DATA_REQUEST,
    requestSaveOnboardingData,
  );
  yield takeEvery(
    OnboardingTypes.INVITE_USERS_REQUEST,
    requestInviteUsers,
  );
  yield takeEvery(
    OnboardingTypes.GET_FIRST_ONBOARDING_STEPS_REQUEST,
    requestGetFirstOnboardingSteps,
  );
  yield takeEvery(
    OnboardingTypes.SAVE_FIRST_ONBOARDING_STEPS_REQUEST,
    requestSaveFirstOnboardingSteps,
  );
}
